import Vue from 'vue';
import Vuetify, { VSnackbar } from 'vuetify/lib'
import VuetifyToast from 'vuetify-toast-snackbar';

/* Vue.use(VuetifyToast, {
    x: 'middle',
    y: 'top'
}); */

Vue.use(Vuetify, {
    components: {
        VSnackbar
    }
})
    
const opts = {
    x: 'middle',
    y: 'top'
}; // your options

const vuetify = new Vuetify();

export default vuetify;

/* Vue.use(VuetifyToast, { $vuetify: vuetify.framework }); */

Vue.use(VuetifyToast, { 
    $vuetify: vuetify.framework, 
    x: 'middle', 
    y: 'top',
    timeout: 6000,
   /*  color: 'info', 
    icon: '', 
    iconColor: '',  
    classes: [ 'body-2' ], 
    dismissable: true, 
    multiLine: false,  
    queueable: false, 
    showClose: false, 
    closeText: '', 
    closeColor: '',
    shorts: { custom: { color: 'purple' } },
    property: '$toast' */
});